export default {
  mutations: {
    AUTHORIZE: 'AUTHORIZE',
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    AUTH_ERROR: 'AUTH_ERROR',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    AUTH_PERMISSIONS: 'AUTH_PERMISSIONS',
    SET_AUTH_USER: 'SET_AUTH_USER',
    SET_TOKEN_CONFIGURATION: 'SET_TOKEN_CONFIGURATION',
    SET_UPDATE_AUTH_USER: 'SET_UPDATE_AUTH_USER',
    SET_CONCAT_FEATURES_FLAG_TO_THE_PERMISSIONS:
      'SET_CONCAT_FEATURES_FLAG_TO_THE_PERMISSIONS',
    SET_COMMPIX_CREDENTIALS: 'SET_COMMPIX_CREDENTIALS',
    SET_COMMPIX_AUTH_TOKEN: 'SET_COMMPIX_AUTH_TOKEN',
    COMMPIX_AUTH_LOGOUT: 'COMMPIX_AUTH_LOGOUT',
  },
  getters: {
    IS_AUTHENTICATED: 'IS_AUTHENTICATED',
    AUTH_STATUS: 'AUTH_STATUS',
    AUTH_PERMISSIONS: 'AUTH_PERMISSIONS',
    GET_AUTH_USER: 'GET_AUTH_USER',
    PERMISSIONS: 'PERMISSIONS',
    GET_USER_SESSION: 'GET_USER_SESSION',
    GET_COMMPIX_CREDENTIALS: 'GET_COMMPIX_CREDENTIALS',
  },
  actions: {
    AUTHORIZE: 'AUTHORIZE',
    AUTHORIZE_COMMPIX: 'AUTHORIZE_COMMPIX',
    SEND_PASSWORD_INSTRUCTIONS: 'SEND_PASSWORD_INSTRUCTIONS',
    AUTH_REQUEST: 'AUTH_REQUEST',
    AUTH_LOGOUT: 'AUTH_LOGOUT',
    COMMPIX_AUTH_LOGOUT: 'COMMPIX_AUTH_LOGOUT',
    RESET_PASSWORD: 'RESET_PASSWORD',
    SEND_UNLOCK_INSTRUCTIONS: 'SEND_UNLOCK_INSTRUCTIONS',
    UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    EXPIRES_IN: 'EXPIRES_IN',
    GET_COMMPIX_CREDENTIALS: 'GET_COMMPIX_CREDENTIALS',
    AUTH_COMMPIX: 'AUTH_COMMPIX',
  },
};
